import { render } from "./NInputColor.vue?vue&type=template&id=4874b9ef&ts=true"
import script from "./NInputColor.vue?vue&type=script&lang=ts"
export * from "./NInputColor.vue?vue&type=script&lang=ts"

import "./NInputColor.vue?vue&type=style&index=0&id=4874b9ef&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__